import { render, staticRenderFns } from "./pushHonorConfig.vue?vue&type=template&id=35feff72&scoped=true"
import script from "./pushHonorConfig.vue?vue&type=script&lang=js"
export * from "./pushHonorConfig.vue?vue&type=script&lang=js"
import style0 from "./pushHonorConfig.vue?vue&type=style&index=0&id=35feff72&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35feff72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35feff72')) {
      api.createRecord('35feff72', component.options)
    } else {
      api.reload('35feff72', component.options)
    }
    module.hot.accept("./pushHonorConfig.vue?vue&type=template&id=35feff72&scoped=true", function () {
      api.rerender('35feff72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/components/pushHonorConfig.vue"
export default component.exports